import { render } from "./Tree.vue?vue&type=template&id=0528ec02"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"

import "./Tree.vue?vue&type=style&index=0&id=0528ec02&lang=scss"
script.render = render

export default script